var exports = {
  "kL": "container__W3ZoTF",
  "Qq": "text__tfxffv",
  "KQ": "loadingText__5UL5kk",
};

module.exports = exports;
